export const summaryRows: string[] = [
  'Tomo 1 — Fundamentos de la Gestión Ambiental',
  'Tomo 2 — Recursos Naturales y Gestión Sostenible',
  'Tomo 3 — Aspectos, Impactos y Riesgos Ambientales',
  'Tomo 4 — Gestión del Agua, Suelo y Contaminación',
  'Tomo 5 — Gestión de Residuos y Economía Circular',
  'Tomo 6 — Biodiversidad, Ecosistemas y Conservación',
  'Tomo 7 — Cambio Climático y Desafíos Ambientales',
  'Tomo 8 — Sistemas de Gestión Ambiental y Mejora Continua',
  'Tomo 9 — Enseñanza de la Gestión Ambiental: Planificación y Proyectos 2026',
  'Bono 1 — 150 Actividades de Gestión Ambiental',
  'Bono 2 — Kit de Evaluación Completo',
  'Bono 3 — 100 Casos Prácticos',
  'Bono 4 — 100 Proyectos Ambientales',
  'Bono 5 — 100 Estrategias de Gestión Institucional',
  'Garantía de 7 días sin preguntas',
  'Acceso inmediato',
];
